import { DbInstance } from "../utils/constants";
import jsonDb from "./local";

export type ID = string | number;
export type Filter = (...args: any[]) => boolean;

export interface DbOptions {
	avoidUUID?: boolean;
}

export interface LocalDb {
	create<T>(data: T, partition?: string, options?: DbOptions): Promise<any>;
	update<T>(id: ID, patch: T, partition?: string): Promise<any>;
	delete(id: ID, partition?: string): Promise<any>;
	get<T>(id: ID, partition?: string): Promise<T>;
	find<T>(filter?: Filter, partition?: string): Promise<T[]>;
	exists(key: string): Promise<boolean>;
}

const instances = {
	[DbInstance.JSON_DB]: jsonDb,
};

export default function resolveDb<T>(instance: DbInstance): LocalDb {
	return instances[instance];
}
